/* eslint-disable max-len */
// @flow
/* eslint-disable react/no-danger */
import * as React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { checkAuthState, logout } from 'client/actions';
import { Header, OneVotingPopupRestriction, AlreadyVotesPopup } from 'client/components/common';
import { type EnhancedProps, withTransition } from 'client/components/common/HOCs/with-transition';
import * as css from './Main.scss';
import Intro from './Intro';
import MainContent from './MainContent';
import Final from './Final';

type Props = {|
	...EnhancedProps,
	className?: string,
	in: boolean,
	checklistInfo: ChecklistsItem,
	galleryItems: Array<GalleryItemInfo>,
	location: RouterLocation,
	checkAuthState: typeof checkAuthState,
	logout: typeof logout,
|};

type State = {|
	view: string,
	isOneVotingPopupShow: boolean,
	isAlreadyVotesWithAuthPopupShow: boolean,
|};

const views = {
	intro: 'intro',
	mainContent: 'mainContent',
	final: 'final',
};

class Main extends React.PureComponent<Props, State> {
	transitionCompleteTimeout: TimeoutID;

	static defaultProps = {
		className: '',
	};

	state = {
		view: views.intro,
		isOneVotingPopupShow: false,
		isAlreadyVotesWithAuthPopupShow: false,
	};

	async componentDidMount() {
		const { onTransitionComplete, checklistInfo } = this.props;

		const font = _.get(checklistInfo, 'graphics.font', 'Arial');
		const isHideMainPage = _.get(checklistInfo, 'general.isHideMainPage', false);
		const checklistId = _.get(checklistInfo, 'id', '');
		const isWithRegistration = _.get(checklistInfo, 'general.isWithRegistration', false);

		// if admin first chose the isOneVotingPerUser option (in admin pannel) and the user voted,
		// but after that admin removed this option we clean the storage and dont show one voting popup

		if (
			!_.get(checklistInfo, 'general.isOneVotingPerUser') &&
			localStorage.getItem(`checklist-${checklistInfo.name}`)
		) {
			localStorage.removeItem(`checklist-${checklistInfo.name}`);
		}

		const storageOneVotingForChecklist = localStorage.getItem(`checklist-${checklistInfo.name}`);
		if (document && document.body) {
			document.body.setAttribute('style', `font-family:${font};`);
		}
		this.transitionCompleteTimeout = setTimeout(onTransitionComplete, parseInt(css.transitionIn, 10));

		if (storageOneVotingForChecklist) {
			this.setState({
				isOneVotingPopupShow: true,
			});
		}
		// Check if need to hide main page (only if admin set hide main page)
		if (isHideMainPage) {
			this.setState({
				view: views.mainContent,
			});
		}

		// Check if user voted before on checklist with registration (need to show popup)
		if (
			!isHideMainPage &&
			isWithRegistration &&
			localStorage.getItem(`voted-checklist-with-registration-${checklistId}`)
		) {
			this.setState({ isAlreadyVotesWithAuthPopupShow: true });
		}

		// Check if user loged in before on checklist with registration and didnt vote (simple reload page)
		if (
			!isHideMainPage &&
			isWithRegistration &&
			localStorage.getItem(`current-checklist-withregistration`) === checklistId &&
			!localStorage.getItem(`voted-checklist-with-registration-${checklistId}`)
		) {
			this.setState({
				view: views.mainContent,
			});
		}

		// Check if user switched between checklists
		if (
			!isHideMainPage &&
			isWithRegistration &&
			localStorage.getItem(`current-checklist-withregistration`) &&
			localStorage.getItem(`current-checklist-withregistration`) !== checklistId
		) {
			localStorage.removeItem('current-checklist-withregistration');
			this.props.logout();
		}

		// if (
		// 	!isHideMainPage &&
		// 	isWithRegistration &&
		// 	localStorage.getItem(`checklist-with-registration-${checklistId}`)
		// ) {
		// 	this.setState({ isAlreadyVotesWithAuthPopupShow: true });
		// } else {
		// 	await this.props.checkAuthState({ checklistId });
		// }
	}

	componentDidUpdate(prevProps: Props) {
		if (this.props.in !== prevProps.in) {
			const { onTransitionComplete } = this.props;
			let duration = parseInt(this.props.in ? css.transitionIn : css.transitionOut, 10);

			if (!this.props.in) {
				duration = 0;
			}
			clearTimeout(this.transitionCompleteTimeout);
			this.transitionCompleteTimeout = setTimeout(onTransitionComplete, duration);
		}
	}

	resetScroll = () => {
		window.scrollTo(0, 0);
	};

	onCampaignStart = () => {
		this.resetScroll();
		this.setState({
			view: views.mainContent,
		});
	};

	onFinishClick = () => {
		this.resetScroll();
		this.setState({ view: views.final });
	};

	onBackClick = () => {
		this.resetScroll();
		this.setState({ view: views.mainContent });
	};

	showAlreadyVotesPopup = () => {
		this.setState({ isAlreadyVotesWithAuthPopupShow: true });
	};

	renderViews() {
		const { checklistInfo, galleryItems, location } = this.props;
		const galleryData = {
			gallery: galleryItems,
			checklistInfo,
		};

		const parentURL = `${location.pathname}${location.search}`;

		// if (this.state.isBusy) {
		// 	return this.renderLoader();
		// }
		switch (this.state.view) {
			case views.intro:
				return (
					<Intro
						in={this.state.view === views.intro}
						checklistInfo={checklistInfo}
						onCampaignStart={this.onCampaignStart}
						parentURL={parentURL}
						location={location}
						showAlreadyVotesPopup={this.showAlreadyVotesPopup}
					/>
				);

			case views.mainContent:
				return (
					<MainContent
						in={this.state.view === views.mainContent}
						galleryData={galleryData}
						onFinishClick={this.onFinishClick}
						parentURL={parentURL}
						location={location}
					/>
				);

			case views.final:
				return (
					<Final
						in={this.state.view === views.final}
						checklistInfo={checklistInfo}
						parentURL={parentURL}
						location={location}
					/>
				);
			default:
			// return this.renderLoader();
		}
	}

	render() {
		const { className, transitionState, checklistInfo, location } = this.props;
		const { view, isOneVotingPopupShow, isAlreadyVotesWithAuthPopupShow } = this.state;
		const logo1 = _.get(checklistInfo, 'graphics.headerLogoFirst', {});
		const logo1Link = _.get(checklistInfo, 'graphics.headerLogoFirstLink', '');
		const headerBackground = _.get(checklistInfo, 'graphics.headerBackgroundColor', '');
		const isTransparentHeader = _.get(checklistInfo, 'graphics.isTransparentHeader', false);
		const isTransparentHeaderOnGallery = _.get(checklistInfo, 'graphics.isTransparentHeaderOnGallery', false);
		const isTransparentHeaderOnThanks = _.get(checklistInfo, 'graphics.isTransparentHeaderOnThanks', false);
		const compainLogo = _.get(checklistInfo, 'graphics.headerLogoCenter', {});
		const bodyBackground = _.get(checklistInfo, 'graphics.bodyBackgroundColor', '#000');
		const shareButtonIconColor = _.get(checklistInfo, 'graphics.shareButtonIconColor', '#fff');
		const siteName = _.get(checklistInfo, 'general.url', '');
		const shareResults = _.get(checklistInfo, 'form.enableShareResults', false);
		const desktopBgVideo = _.get(checklistInfo, 'graphics.mainBackgroundVideo', false);
		const mobileBgVideo = _.get(checklistInfo, 'graphics.mainBackgroundMobileVideo', false);
		const isWithVideoBg = !!(desktopBgVideo || mobileBgVideo);

		const isBigRightLogoDesk = _.get(checklistInfo, 'graphics.isBigDesktopRightLogo', false);
		const isBigRightLogoMob = _.get(checklistInfo, 'graphics.isBigMobileRightLogo', false);
		const logo2 = _.get(checklistInfo, 'graphics.headerLogoSecond', {});
		const logo2Big = _.get(checklistInfo, 'graphics.headerLogoSecondBig', {});
		const logo2Link = _.get(checklistInfo, 'graphics.headerLogoSecondLink', '');

		const logo3 = _.get(checklistInfo, 'graphics.headerLogoThird', {});
		const logo3Link = _.get(checklistInfo, 'graphics.headerLogoThirdLink', '');
		const isHideLogoCenterForMobile = _.get(checklistInfo, 'graphics.isHideLogoCenterForMobile', false);

		const shareTitle = _.get(checklistInfo, 'general.shareTitle', '');

		const headerData = {
			logo1,
			logo1Link,
			logo2,
			logo2Big,
			logo2Link,
			logo3,
			logo3Link,
			isBigRightLogoDesk,
			isBigRightLogoMob,
			headerBackground,
			compainLogo,
			shareButtonIconColor,
			siteName,
			isTransparentHeader,
			isTransparentHeaderOnGallery,
			isTransparentHeaderOnThanks,
			view,
			isWithVideoBg,
			isHideLogoCenterForMobile,
		};

		const isLogoVisible = [views.mainContent].includes(this.state.view);
		const isHeaderSociallsVisible = [views.final].includes(this.state.view);
		// Show back btn on final screen, and if it isnot these checklists https://list.mako.co.il/eretznehederetcharacters or https://list.mako.co.il/commercialstage3
		const isBackBtnVisible =
			([views.final].includes(this.state.view) && location.pathname !== '/eretznehederetcharacters') ||
			([views.final].includes(this.state.view) && location.pathname !== '/commercialstage4');
		const isOnHorizontalChecklist = _.get(checklistInfo, 'cardsType', '0');

		// SPECIAL only for these 5 checklists
		const isTotalyHideShareBtns =
			location.pathname === '/eretznehederetvideo' ||
			location.pathname === '/eretznehederetsongs' ||
			location.pathname === '/eretznehederetcharacters' ||
			(location.pathname === '/commercials' && this.state.view !== views.intro) ||
			location.pathname === '/commercialstage2' ||
			location.pathname === '/commercialstage3' ||
			location.pathname === '/commercialstage4';
		return (
			<div
				className={classNames(css.main, css[transitionState], className)}
				style={{ backgroundColor: bodyBackground }}
			>
				<Header
					data={headerData}
					isLogoVisible={isLogoVisible}
					isBackBtnVisible={isBackBtnVisible}
					isHeaderSociallsVisible={isHeaderSociallsVisible}
					shareResults={shareResults}
					onBackClick={this.onBackClick}
					shareTitle={shareTitle}
					isOnHorizontalChecklist={isOnHorizontalChecklist}
					isTotalyHideShareBtns={isTotalyHideShareBtns}
				/>
				{this.renderViews()}
				<OneVotingPopupRestriction isShow={isOneVotingPopupShow || isAlreadyVotesWithAuthPopupShow} />
			</div>
		);
	}
}

export default withTransition(Main);
